// API Configuration
// Uses environment variable REACT_APP_API_URL if set, otherwise defaults to localhost
// For production, set REACT_APP_API_URL=https://api.demo.veritage.io (or your production API URL)
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.veritage.io';

export default {
  API_BASE_URL,
};
